
<h1 mat-dialog-title style="font-family: 'Poppins';">{{labels.lblDelPicture}}</h1>
<div mat-dialog-content style="font-family: 'Poppins';">
  <p>{{labels.lblDeleteThisUsersProfilePicture}}</p>
</div>
<div mat-dialog-actions style="text-align: center; ">
  <button class="btn" mat-button (click)="onNoClick()">{{labels.lblNo}}</button>
  <button class="btn"  (click)="deleteImage()" cdkFocusInitial>{{labels.lblDelete}}</button>
</div>
